export const API_ENDPOINTS = {
  shopList: 'current-user/carts/${cartId}/stores/search',
};
